import React from "react";

export type MobileBadgeTone =
    | "primary"
    | "success"
    | "warning"
    | "danger"
    | "neutral"
    | "extra"
    | "abscence";

const TONES: Record<MobileBadgeTone, { color: string; bg: string; border: string }> = {
    primary: { color: "#0084D1", bg: "#E6F0FB", border: "#D1E4FA" },
    success: { color: "#059669", bg: "#ECFDF5", border: "#A7F3D0" },
    warning: { color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" },
    danger: { color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" },
    neutral: { color: "#334155", bg: "#F1F5F9", border: "#CBD5E1" },
    extra: { color: "#7C3AED", bg: "#F5F3FF", border: "#DDD6FE" },
    abscence: { color: "#B36B00", bg: "#FFF4E5", border: "#FFE0B2" },
};

interface MobileBadgeProps {
    /** Texto principal. Com "truncate", é a parte que leva reticências. */
    label: React.ReactNode;
    /** Texto que nunca é cortado (ex.: "(8h)"). */
    suffix?: React.ReactNode;
    tone?: MobileBadgeTone;
    size?: "sm" | "md";
    /** Permite ao badge encolher e truncar o "label" com reticências. */
    truncate?: boolean;
    title?: string;
    className?: string;
    style?: React.CSSProperties;
    onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

const MobileBadge: React.FC<MobileBadgeProps> = ({
    label,
    suffix,
    tone = "neutral",
    size = "md",
    truncate = false,
    title,
    className = "",
    style,
    onClick,
}) => {
    const colors = TONES[tone];

    return (
        <span
            className={`${size === "sm" ? "badge-squircle-sm" : "badge-squircle"} ${onClick ? "cursor-pointer" : ""} ${className}`}
            title={title}
            onClick={onClick}
            style={{
                gap: suffix ? "3px" : undefined,
                // justify-content: flex-start evita que o texto centrado seja cortado dos dois lados
                ...(truncate
                    ? { justifyContent: "flex-start", minWidth: 0, maxWidth: "100%" }
                    : { flexShrink: 0 }),
                color: colors.color,
                backgroundColor: colors.bg,
                border: `1px solid ${colors.border}`,
                ...style,
            }}
        >
            {truncate ? (
                <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis" style={{ minWidth: 0 }}>
                    {label}
                </span>
            ) : (
                label
            )}
            {suffix && <span className="flex-shrink-0">{suffix}</span>}
        </span>
    );
};

export default MobileBadge;
